const holidays: Date[] = [
  // nieuwjaar
  new Date("2019/01/01"),
  new Date("2020/01/01"),
  new Date("2021/01/01"),
  new Date("2022/01/01"),
  new Date("2023/01/01"),
  // paasmaandag
  new Date("2019/04/22"),
  new Date("2020/04/13"),
  new Date("2021/04/05"),
  new Date("2022/04/18"),
  new Date("2023/04/10"),

  // 1 mei -> dag van de arbeid
  new Date("2019/05/01"),
  new Date("2020/05/01"),
  new Date("2021/05/01"),
  new Date("2022/05/01"),
  new Date("2023/05/01"),
  // hemelvaart
  new Date("2019/05/30"),
  new Date("2020/05/21"),
  new Date("2021/05/13"),
  new Date("2022/05/26"),
  new Date("2023/05/18"),
  // pinkstermaandag
  new Date("2019/06/10"),
  new Date("2020/06/01"),
  new Date("2021/05/24"),
  new Date("2022/06/06"),
  new Date("2023/05/29"),
  // 21 juli -> nationale feestdag
  new Date("2019/07/21"),
  new Date("2020/07/21"),
  new Date("2021/07/21"),
  new Date("2022/07/21"),
  new Date("2023/07/21"),
  // 15 augustus -> tenhemelopneming
  new Date("2019/08/15"),
  new Date("2020/08/15"),
  new Date("2021/08/15"),
  new Date("2022/08/15"),
  new Date("2023/08/15"),
  // 1 november -> allerheiligen
  new Date("2019/11/01"),
  new Date("2020/11/01"),
  new Date("2021/11/01"),
  new Date("2022/11/01"),
  new Date("2023/11/01"),
  // 11 november -> wapenstilstand
  new Date("2019/11/11"),
  new Date("2020/11/11"),
  new Date("2021/11/11"),
  new Date("2022/11/11"),
  new Date("2023/11/11"),
  // 25 december -> kerstmis
  new Date("2019/12/25"),
  new Date("2020/12/25"),
  new Date("2021/12/25"),
  new Date("2022/12/25"),
  new Date("2023/12/25"),
];

export default holidays;
